import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { ProductContext } from "../models/ProductContext";

export default function Navbar() {
  const [cart, , , , , , setCategorySlug] = useContext(ProductContext);

  let price = 0;
  cart.forEach((product: any) => {
    price += product.price * product.quantity;
  });

  return (
    <header>
      <div
        className="top-header fixed-top bg-white"
        style={{ maxHeight: "50px" }}
      >
        <div className="container  ">
          <nav>
            <ul className="d-flex justify-content-end ">
              <li className="nav-item">
                <Link className="nav-link text-secondary" to="/cart">
                  <img
                    className="mr-2"
                    src={require("../assets/user-icon.png")}
                    alt="user icon"
                  />
                  Guest
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-secondary" to="/cart">
                  <img
                    className="mr-2"
                    src={require("../assets/bag-icon.png")}
                    alt="bag icon"
                  />
                  {cart.length} Items
                  <span className="ml-2">$ {price}</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-secondary" to="/search">
                  <img src="assets/search-icon.png" alt="" />
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="main-header text-lg-center mt-5">
        <Link className="navbar-brand d-none d-lg-block" to="/">
          <img
            className="logo"
            width="150"
            src={require("../assets/logo.png")}
            alt="apple-store logo"
          />
        </Link>
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light bg-white">
            <Link className="navbar-brand d-lg-none" to="/">
              <img
                className="logo"
                width="100"
                src={require("../assets/logo.png")}
                alt="apple-store logo"
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav w-100 justify-content-center">
                <li className="nav-item mx-lg-4">
                  <NavLink
                    className="nav-link"
                    exact
                    to="/"
                    activeStyle={{
                      color: "#33a0ff",
                      borderBottom: "2px solid #33a0ff",
                    }}
                  >
                    HOME
                  </NavLink>
                </li>
                <li className="nav-item mx-lg-4">
                  <NavLink
                    className="nav-link"
                    to="/store"
                    activeStyle={{
                      color: "#33a0ff",
                      borderBottom: "2px solid #33a0ff",
                    }}
                  >
                    STORE
                  </NavLink>
                </li>
                <li className="nav-item mx-lg-4">
                  <NavLink
                    className="nav-link"
                    to="/category/iphone"
                    onClick={() => setCategorySlug("iphone")}
                    activeStyle={{
                      color: "#33a0ff",
                      borderBottom: "2px solid #33a0ff",
                    }}
                  >
                    IPHONE
                  </NavLink>
                </li>
                <li className="nav-item mx-lg-4">
                  <NavLink
                    className="nav-link"
                    to="/category/ipad"
                    onClick={() => setCategorySlug("ipad")}
                    activeStyle={{
                      color: "#33a0ff",
                      borderBottom: "2px solid #33a0ff",
                    }}
                  >
                    IPAD
                  </NavLink>
                </li>
                <li className="nav-item mx-lg-4">
                  <NavLink
                    className="nav-link"
                    to="/category/macbook"
                    onClick={() => setCategorySlug("macbook")}
                    activeStyle={{
                      color: "#33a0ff",
                      borderBottom: "2px solid #33a0ff",
                    }}
                  >
                    MACBOOK
                  </NavLink>
                </li>
                <li className="nav-item mx-lg-4">
                  <NavLink
                    className="nav-link"
                    to="/category/accessories"
                    onClick={() => setCategorySlug("accessories")}
                    activeStyle={{
                      color: "#33a0ff",
                      borderBottom: "2px solid #33a0ff",
                    }}
                  >
                    ACCESSORIES
                  </NavLink>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
